import React, { useState, ChangeEvent, useEffect } from 'react';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { isObjectEmpty } from '../../../../utils/objectCheck';
import DynamicFormExtender from '../../../../yoello-lib/modules/dynamicForms/DynamicFormExtender';
import PricingOption from '../../../../yoello-lib/modules/dynamicForms/CustomFormComponents/PricingOptions';
import ICommonFormProps from '../../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps';
import { createPricingOption } from '../ProductModifyDialog';
import AddToExtraGroup from "./AddToExtraGroup";
import FormElement from '../../../../yoello-lib/modules/dynamicForms/FormElement';
interface IExtrasFormComponentProps extends ICommonFormProps {
    setValue: (name: string, value: any) => void;
}
const key = "is_extra";
/**
 * Form component for handling extra pricing options for menu items
 */
const ExtrasFormComponent = (props: IExtrasFormComponentProps): JSX.Element => {
    const [isExtra, setIsExtra] = useState(false);
    const initialPricingOption = createPricingOption();
    const { t } = useTranslation();
    const onIsExtraCheck = (ev: ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setIsExtra(checked);
        /**Removes the value if you uncheck  */
        if (props.setValue && !checked) {
            props.setValue(props.keyName, {});
        }
    };
    useEffect(() => {
        if (props.value !== undefined
            && !isObjectEmpty(props.value)) {
            setIsExtra(true);
        }
        //@ts-ignore
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        props.setValue(key, isExtra);
        // eslint-disable-next-line
    }, [isExtra]);
    return <FormElement {...props} keyName={key}>
        <>
            <FormControlLabel label={t("menu.extras.extracheckbox")}
                control={
                    <Checkbox name={"is_extra"}
                        key={"is_extra"}
                        onChange={onIsExtraCheck}
                        checked={isExtra}
                        disabled={props.disabled} />
                }
            />
            {isExtra && <>
                {!props.formProps?.removeAddToExtraGroup && <AddToExtraGroup {...props} label={t("menu.extras.addToExtraGroup")} />}

                <DynamicFormExtender {...props}
                    disabled={props.disabled}
                    value={isObjectEmpty(props.value) ? { "extra_priceOps": initialPricingOption } : props.value}
                    formProps={{
                        buttonLabel: 'menu.priceoptions.extrabutton',
                        createNewObjectFunction: createPricingOption,
                        Component: PricingOption,
                    }} />
            </>
            }
        </>
    </FormElement >
};

export default ExtrasFormComponent;